import { Table } from "reactstrap";
import React from "react";

const MaandoverzichtTable = ({ arrMonth }) => {
    // console.log(data);
    // add animation when remove data (row)

    return (
        <Table hover size="sm" borderless className="mb-0 maandoverzicht-table-style">
            <thead>
                <tr>
                    <th>Maand</th>
                    <th>Jaar</th>
                    <th>Uren cumulatief</th>
                    <th>Uren totaal</th>
                </tr>
            </thead>
            <tbody>
                {arrMonth.map((value) => {
                    return (
                        <tr>
                            <td>{value.monthName !== undefined ? value.monthName : ''}</td>
                            <td>{value.year !== undefined ? value.year : ''}</td>
                            <td>{value.cumulatief !== undefined ? Number(value.cumulatief).toFixed(1) : ''}</td>
                            <td>{value.totaal_uren !== undefined ? Number(value.totaal_uren).toFixed(1) : ''}</td>
                        </tr>
                    )
                })
                }
            </tbody>
        </Table>
    );
};

export default MaandoverzichtTable;